var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KTCard',{ref:"preview",attrs:{"title":_vm.title,"example":true,"id":"dashboard-box"},scopedSlots:_vm._u([{key:"toolbar",fn:function(){return [_vm._t("toolbar")]},proxy:true},{key:"body",fn:function(){return [_vm._t("preview")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }